import React from 'react';
import { Box } from '@mui/material';
import ContentLoader from 'react-content-loader';

const SkeletonTextEditor = () => (
  <Box sx={{ width: '100%', p: 2, backgroundColor: '##252224', borderRadius: '4px' }}>
    <ContentLoader
      speed={2}
      width="100%"
      height={300}
      backgroundColor="#3D393B"
      foregroundColor="#4A494B"
    >
      {/* Toolbar buttons */}
      <rect x="0" y="10" rx="3" ry="3" width="30" height="30" />
      <rect x="40" y="10" rx="3" ry="3" width="30" height="30" />
      <rect x="80" y="10" rx="3" ry="3" width="30" height="30" />
      <rect x="120" y="10" rx="3" ry="3" width="30" height="30" />
      <rect x="160" y="10" rx="3" ry="3" width="30" height="30" />
      <rect x="200" y="10" rx="3" ry="3" width="30" height="30" />

      {/* Editor area */}
      <rect x="0" y="60" rx="5" ry="5" width="100%" height="200" />

      {/* Save and cancel buttons */}
      <rect x="0" y="280" rx="5" ry="5" width="80" height="30" />
      <rect x="100" y="280" rx="5" ry="5" width="80" height="30" />
    </ContentLoader>
  </Box>
);

export default SkeletonTextEditor;
